export default class AdditionalMaterialsView extends Backbone.View
  events:
    "change .js-additional-materials-field" : "additionalMaterialsChanged"
    "click .js-delete-additional-materials" : "deleteAdditionalMaterials"

  initialize: (options) ->
    @$additionalMaterialsInput    = @$(".js-additional-materials-field")
    @$additionalMaterialsFilename = @$(".js-additional-materials-file-name")
    @$deleteAdditionalMaterialsInput   = @$(".js-delete-additional-materials-field")

  additionalMaterialsChanged: (event) ->
    fileInput = event.currentTarget
    if fileInput.files
      @$additionalMaterialsFilename.html("<span class='file-name'>#{fileInput.files[0].name}</span>")

    @$deleteAdditionalMaterialsInput.val("false")

  deleteAdditionalMaterials: (event) ->
    @$deleteAdditionalMaterialsInput.val("true")
    @$additionalMaterialsFilename.text("")

    # Cleans out the file input element
    @$additionalMaterialsInput.wrap("<form>").closest("form").get(0).reset()
    @$additionalMaterialsInput.unwrap()



// WEBPACK FOOTER //
// ./app/javascript/backbone/settings/views/publication/additional_materials_view.js.coffee